if (!customElements.get('cart-notification')) {
  class CartNotification extends HTMLElement {
    constructor() {
      super()
      this.initialized = false
      this.cartItems = []
    }

    connectedCallback() {
      this.addEventListener('add-to-cart', this.addToCart)
      this.addEventListener('remove-from-cart', this.removeFromCart)
      if (!this.initialized) {
        this.initialized = true
      }
    }

    disconnectedCallback() {
      this.removeEventListener('add-to-cart', this.addToCart)
      this.removeEventListener('remove-from-cart', this.removeFromCart)
    }

    addToCart(event) {
      const { config, onSucceed, onFail, formData } = event.detail
      fetch(`${window.routes.cart_add_url}`, config)
        .then((res) => {
          console.log('Loggin Response', res)
          if (res.redirected) {
            return res
          }
          return res.json()
        })
        .then((response) => {
          console.log('RESPONSE:', response)
          this.cartItems.push(response)

          onSucceed(response)
        })
        .catch((e) => onFail(e))
    }

    removeFromCart(event) {
      const { config, onSucceed, onFail } = event.detail
      console.log(event.detail)
      fetch('/cart/change.js', config)
        .then((response) => response.json())
        .then((response) => {
          this.cartItems = response.items
          onSucceed(response)
        })
        .catch((error) => onFail(error))
    }
  }
  customElements.define('cart-notification', CartNotification)
}
